import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Form Master Fitur"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, " Data Master Fitur ")
], -1)
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Fitur", -1)
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, " Tanggal Release", -1)
const _hoisted_11 = { class: "col-lg-12 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Deskripsi", -1)
const _hoisted_13 = { class: "col-lg-6 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Programmer", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: ""
}, "List Programmer", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Letak Fitur", -1)
const _hoisted_19 = { class: "col-lg-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Status", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-lg-12 mt-2" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "is_default",
  class: "form-check-label"
}, " Apakah Fitur Default PSP ? ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-4" }, "Module Detail", -1)
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Module Key"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Module Descriptions"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Default"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status")
  ])
], -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { width: "10%" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "d-flex gap-3"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill text-danger" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "text-left" }
const _hoisted_38 = { width: "30%" }
const _hoisted_39 = { width: "40%" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = ["onUpdate:modelValue", "checked"]
const _hoisted_42 = {
  class: "text-center",
  style: {"padding-left":"auto","padding-right":"auto"}
}
const _hoisted_43 = { class: "row align-items-center justify-content-around" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_48 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "name",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Fitur",
                    modelValue: _ctx.featureData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.featureData.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "releaseDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Release",
                    modelValue: _ctx.featureData.releaseDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.featureData.releaseDate) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control form-control-lg",
                    type: "text",
                    placeholder: "",
                    name: "note",
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.featureData.description) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.featureData.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.featureData.programmer) = $event))
                  }, [
                    _hoisted_15,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programmers, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, _toDisplayString(item), 9, _hoisted_16))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.featureData.programmer]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.featureData.position) = $event)),
                    "aria-label": "Default select example"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.location_options, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: "item"
                      }, _toDisplayString(item.toUpperCase()), 1))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.featureData.position]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.featureData.status) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, _toDisplayString(item), 9, _hoisted_21))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.featureData.status]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "is_default",
                      id: "is_default",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.featureData.is_default) = $event)),
                      checked: _ctx.featureData.is_default
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, _ctx.featureData.is_default]
                    ]),
                    _hoisted_25
                  ])
                ])
              ]),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("table", _hoisted_28, [
                  _hoisted_29,
                  (_ctx.moduleDetail.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleDetail, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_31, [
                              (index + 1 === _ctx.moduleDetail.length)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-sm btn-info",
                                    onClick: ($event: any) => (_ctx.addModuleDetail(index))
                                  }, " tambah ", 8, _hoisted_32))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", {
                                      class: "",
                                      onClick: ($event: any) => (_ctx.removeDetail(index))
                                    }, _hoisted_36, 8, _hoisted_34),
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(index + 1), 1)
                                  ]))
                            ]),
                            _createElementVNode("td", _hoisted_38, [
                              _createVNode(_component_Field, {
                                type: "text",
                                name: `moduleKey${index}`,
                                class: "form-control form-control-sm required",
                                modelValue: _ctx.moduleDetail[index].moduleKey,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.moduleDetail[index].moduleKey) = $event)
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_39, [
                              _createVNode(_component_Field, {
                                type: "text",
                                name: `moduleDescription${index}`,
                                class: "form-control form-control-sm required",
                                modelValue: _ctx.moduleDetail[index].moduleDescription,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.moduleDetail[index].moduleDescription) = $event)
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_40, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input mx-auto",
                                  type: "checkbox",
                                  name: "is_default",
                                  id: "is_default",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.moduleDetail[index].is_default) = $event),
                                  checked: _ctx.moduleDetail[index].is_default
                                }, null, 8, _hoisted_41), [
                                  [_vModelCheckbox, _ctx.moduleDetail[index].is_default]
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_Switch, {
                                  "is-active": item.status,
                                  "non-active-value": "Non Active",
                                  "active-value": "Active",
                                  editable: true,
                                  "model-key": index,
                                  modelValue: item.status,
                                  "onUpdate:modelValue": ($event: any) => ((item.status) = $event)
                                }, null, 8, ["is-active", "model-key", "modelValue", "onUpdate:modelValue"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_44, _hoisted_46))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/superadmin/master-feature/data')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_48, _hoisted_51, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ], 64))
}